import { NgModule } from "@angular/core";
import { DashboardModule } from "./dashboard/dashboard.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DashbardNavModule } from "./dashboard/dashbard-nav/dashbard-nav.module";
import { RouterModule } from "@angular/router";
import { PageHeaderModule } from "./shared/page-header/page-header.module";
import { SaveChangeGaurd } from "@tmhcc/global-services";
import { LoadingModule, LoaderService } from "@tmhcc-ng-lib/framwork/loader";
import { QuotePolicyInfoModule } from "./shared/quote-policy-info/quote-policy-info.module";
import { DocumentModule } from "./quote/document/document.module";
import { KnrDashboardModule } from './knr-dashboard/knr-dashboard.module';
import { WUWDashboardModule } from './wuw-dashboard/wuw-dashboard.module';
//import { KnrAccountSetupModule } from './knr-dashboard/knr-account-setup/knr-account-setup.module';
@NgModule({
  imports: [
    DashboardModule,    
    BrowserAnimationsModule,
    DashbardNavModule,
    RouterModule,
    PageHeaderModule,
    LoadingModule,
    QuotePolicyInfoModule, 
    DocumentModule,
    KnrDashboardModule,
    WUWDashboardModule      
  ],
  exports: [],
  providers: [SaveChangeGaurd, LoaderService]  
})
export class EcoModule {}
